import { render, staticRenderFns } from "./CreateEditSample.vue?vue&type=template&id=2b569b44&"
import script from "./CreateEditSample.vue?vue&type=script&lang=js&"
export * from "./CreateEditSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports